var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('Nav'),_c('div',{staticClass:"app-content"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view')],1)],1),_c('Friendship'),_c('Footer'),_c('CopyRight')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }